<ngx-dropzone class="dropzone-section" accept="image/png" [multiple]="false" (change)="onSelect($event)">
  <ngx-dropzone-label>Drag and drop image here (.png)</ngx-dropzone-label>
  <ngx-dropzone-preview *ngFor="let f of files" class="dropzone-preview" [removable]="true" (removed)="onRemove(f)">
    <ngx-dropzone-label>{{ shortName(f.name) }} ({{ f.type }})</ngx-dropzone-label>
  </ngx-dropzone-preview>
</ngx-dropzone>